import React, { useEffect, useState } from "react";
import $ from "jquery";
import moment from "moment/moment";
import { url } from "../../../../Constant";
import axios from "axios";
import { useAuth } from "../../../../Context/AuthProvider";
import { toast } from "react-toastify";

const AddExtensionModal = ({ closeModal, setApicalled }) => {
  const { auth } = useAuth();
  const [loader, setLoader] = useState(false);
  const [errorEnable, setErrorEnable] = useState(false);
  const [groups, setGroups] = useState();
  const [submittedData, setSubmittedData] = useState({
    name: "",
    extension_code: "",
    call_group: "Admin",
  });

  const getGroups = () => {
    let data = {
      package_id: auth.package_id,
      template_name: auth.template_name,
      vpbx_id: auth.vpbx_id,
    };
    axios
      .post(url + "get-groups", data, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      })
      .then(
        (response) => {
          if (response.status === 200) {
            if (response.data.message === "Data Found") {
              setGroups(response.data.data.group_drop_down);
            }
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };
  useEffect(() => {
    getGroups();
  }, []);

  const addExtension = () => {
    setLoader(true);
    setErrorEnable(true);

    if (
      // submittedData.extension_code !== "" &&
      submittedData.name !== "" &&
      submittedData.call_group !== null
    ) {
      let api = "";
      if (auth.role === "2") {
        api = "create-single-extension";
      } else {
        api = "user-create-single-extension";
      }

      axios
        .post(
          url + api,
          {
            vpbx_id: auth.vpbx_id,
            name: submittedData.name,
            // extension_code: parseInt(submittedData.extension_code),
            call_group: submittedData.call_group,
          },
          {
            headers: {
              Authorization: `Bearer ${auth.token}`,
            },
          }
        )
        .then(
          (response) => {
            if (response.data.code === 200) {
              setLoader(false);
              setApicalled(true);
              toast.success("Extension added successfully", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 1500,
              });
              setTimeout(() => {
                closeModal();
              }, 1000);
            } else {
              setLoader(false);

              if (response.data.data.hasOwnProperty("name") === true) {
                response.data.data.name.map((val, index) => {
                  return toast.error(val, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 1500,
                  });
                });
              } else {
                toast.error(response?.data?.message, {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 1500,
                });
              }
            }
          },
          (error) => {
            console.log(error);
          }
        );
    } else {
      setLoader(false);
    }
  };

  return (
    <div
      className="customModal ModalStyle uk-flex-top uk-open uk-flex uk-flex uk-open"
      uk-modal="esc-close: false; bg-close: false"
    >
      <div className="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
        <div className="filterModalContent">
          <div className="modalHeading">
            <h4>Add Extesnion</h4>
          </div>
          <div className="modalForm">
            <form
              action=""
              onSubmit={(e) => {
                e.preventDefault();
                addExtension();
              }}
            >
              <div className="uk-grid uk-grid-small" uk-grid="">
                <div className="uk-width-1-2">
                  <div className="formInputs">
                    <label htmlFor="agent">Extension Number</label>
                    <input
                      type="text"
                      placeholder="please enter extension number"
                      defaultValue={submittedData.name}
                      className="uk-input"
                      onChange={(e) => {
                        setSubmittedData({
                          ...submittedData,
                          name: e.target.value,
                        });
                      }}
                    />
                    {errorEnable && submittedData.name === "" && (
                      <div className="formErrors">
                        Extension Number is required
                      </div>
                    )}
                  </div>
                </div>

                {/* <div className="uk-width-1-2">
                  <div className="formInputs">
                    <label htmlFor="city">Extension Code</label>
                    <input
                      type="text"
                      placeholder="please enter extesnion code"
                      defaultValue={submittedData.extension_code}
                      className="uk-input"
                      onChange={(e) => {
                        setSubmittedData({
                          ...submittedData,
                          extension_code: e.target.value,
                        });
                      }}
                    />
                    {errorEnable && submittedData.extension_code === "" && (
                      <div className="formErrors">
                        Extension Code is required
                      </div>
                    )}
                  </div>
                </div> */}
                {/* <div className="uk-width-1-2">
                  <div className="formInputs">
                    <label htmlFor="type">Call Group</label>
                    <select
                      name="type"
                      value={
                        submittedData.call_group === null
                          ? ""
                          : submittedData.call_group
                      }
                      onChange={(e) => {
                        setSubmittedData({
                          ...submittedData,
                          call_group:
                            e.target.value === "" ? null : e.target.value,
                        });
                      }}
                      className="uk-select"
                    >
                      <option value="" selected disabled>
                        please select call group
                      </option>
                      {groups?.map((val, index) => {
                        return (
                          <option key={index} value={val.group_name}>
                            {val.group_name}
                          </option>
                        );
                      })}
                    </select>
                    {errorEnable && submittedData.call_group === null && (
                      <div className="formErrors">Please select group </div>
                    )}
                  </div>
                </div> */}
                <div className="uk-width-1-2">
                  <div className="formInputs">
                    <label htmlFor="type">Call Group</label>
                    <input
                      id="fromDate"
                      type="text"
                      readOnly
                      value={submittedData?.call_group}
                      className="uk-input"
                    />
                  </div>
                </div>
                <div className="uk-width-1-2"></div>
                <div className="uk-width-1-2"></div>
                <div className="uk-width-1-2"></div>
                <div className="uk-width-1-2">
                  <div className="btnwrp" style={{ float: "right" }}>
                    <button
                      type="button"
                      className="exportData-button"
                      onClick={closeModal}
                    >
                      Cancel
                    </button>
                    <button
                      type="Submit"
                      className="exportData-button"
                      //   onClick={() => getFilterData()}
                    >
                      {loader ? (
                        <div uk-spinner="" className="loader"></div>
                      ) : (
                        "Add"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddExtensionModal;
